import { atom } from 'recoil';
import type { IChart } from './types';
import {
  AXIS_OPTIONS,
  POSITION_OPTIONS,
  TIME_PERIOD,
} from '../../views/add-on/components/charts/constant';

const chart: IChart = {
  datasets: [
    {
      datasource: {},
      metric: null,
      label: '',
      color: '#866cff',
      type: 'bar',
      data: [],
    },
  ],
  style: {
    stacked: false,
    backgroundColor: '#FFFFFF',
    axesColor: '#7E8B9D',
    labelColor: '#546070',
    axis: AXIS_OPTIONS[3],
    position: POSITION_OPTIONS[0],
    borderColor: '#e0e6ee',
  },
  settings: {
    title: '',
    schedule: false,
    period: TIME_PERIOD[0],
    showLastSynced: false,
    isPlanSupportBadge: true,
    badge: false,
    isSparrowBadge: true,
    timeRange: { start: '', end: '', period: '' },
  },
};

export const ChartTabState = atom<string>({
  key: 'chart-tabs',
  default: 'dataset',
});

export const ChartSettingsState = atom({
  key: 'chart-setting',
  default: chart,
});

export const ChartDataState = atom<{
  isLoading: boolean;
  chartURL: string;
  isSuccess?: boolean;
  isError?: boolean;
}>({
  key: 'chart-loading',
  default: {
    isLoading: false,
    chartURL: '',
    isSuccess: false,
    isError: false,
  },
});

export const ChartSettingModalState = atom<boolean>({
  key: 'chart-setting-modal',
  default: false,
});

export const IsEditModeState = atom<boolean>({
  key: 'is-edit-mode',
  default: false,
});

export const updatingChartIds = atom<string[]>({
  key: 'updating-chart-ids',
  default: [],
});
